import { t } from '@lingui/macro';
import { Dashboard } from 'components/Dashboard/Dashboard';
import { DashboardProvider } from 'components/Dashboard/Dashboard.context';
import { useTrackingIdentify } from 'utils/tracking/tracking.hooks';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

import styles from './index.module.css';

export const HomePage = () => {
  useTrackingIdentify();

  return (
    <BaseLayout
      pageTitle={t`Dashboard | Introducer Portal`}
      className={styles.dashboardLayout}
      showDEFooter
    >
      <DashboardProvider>
        <Dashboard />
      </DashboardProvider>
    </BaseLayout>
  );
};
